import * as catalogs from '@/services/catalogs'


export default {
  name: 'fetchesMixin',
  data() {
    return {
      countries: [],
      countriesSelect: [],
      countriesById: [],
      countriesByIdSelect: [],
      deliveryTimeRanges: [],
      deliveryTimeRangesSelect: [],
      areas: [],
      areasSelect: [],
      regions: [],
      regionsSelect: [],
      areasWithCoords: [],
      routingZones: [],
      routingZonesSelect: [],
      routingZonesWithCoords: [],
      warehouses: [],
      warehousesSelect: [],
      warehousesByIdSelect: [],
      shippingSizes: [],
      shippingSizesSelect: [],
      shippingTypes: [],
      shippingTypesSelect: [],
      platforms: [],
      platformsSelect: [],
      vehicleTypes: [],
      vehicleTypesSelect: [],
      roles: [],
      rolesSelect: [],
      receiverTypes: [],
      tobereturnedStatusReasons: [],
      shippingStatusReasons: {},
      eventTypes: [],
      eventTypesSelect: [],
      notificationTypes: [],
      notificationTypesSelect: [],
      industries: [],
      industriesSelect: [],
      companiesSettings: [],
      companiesSegments: [],
      companiesSegmentsSelect: [],
      disableReasons: [],
      disableReasonsSelect: [],
      services: [],
      servicesSelect: [],
      outsourcingModelMappings: [],
      outsourcingModelMappingsSelect: [],
      platforms3p: [],
      platforms3pSelect: [],
      outsourcingCustomizations: [],
      outsourcingCustomizationsSelect: []
    }
  },
  methods: {
    async fetchCountries(params) {
      return catalogs.fetchCountries(params)
        .then(response => {
          this.countries = response.body.data
          this.countriesSelect = this.countries.map((item) => {
            return {
              value: item.iso_code,
              text: item.name
            }
          })
          this.countriesByIdSelect = this.countries.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchCountriesById(params) {
      return catalogs.fetchCountriesById(params)
        .then(response => {
          this.countriesById = response.body.data
          this.countriesByIdSelect = this.countriesById.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchDeliveryTimeRanges(country = null, includes = []) {
      return catalogs.fetchDeliveryTimeRanges(country, includes)
        .then(response => {
          this.deliveryTimeRanges = response.body.data
          this.deliveryTimeRangesSelect = this.deliveryTimeRanges.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchRegions(country = null, type = 'company_management', includes = []) {
      return catalogs.fetchRegions(country, type, includes)
        .then(response => {
          this.regions = response.body.data
          this.regionsSelect = this.regions.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchAreas(country = null, includes = [], prevItems = [], page = 0) {
      return await catalogs.fetchAreas(country, includes, prevItems, page)
        .then(async response => {
          if (response.body.data.length > 0) {
            prevItems = prevItems.concat(response.body.data)
            await this.fetchAreas(country, includes, prevItems, response.body.pagination.page + 1)
          } else {
            this.areas = prevItems
            this.areasSelect = prevItems.map((item) => {
              return {
                value: item.id,
                text: item.name
              }
            })
            this.areasWithCoords = prevItems.map((item) => {
              return {
                id: item.id,
                text: item.name,
                value: {
                  coords: JSON.parse(JSON.stringify(item.area)).coordinates.map(linearRing =>
                    linearRing.slice(0, linearRing.length - 1)
                      .map(([lng, lat]) => ({lat, lng}))
                  )
                }
              }
            })
          }
        })
    },
    async fetchRoutingZones(country = null, includes = [], prevItems = [], page = 0) {
      return await catalogs.fetchRoutingZones(country, includes, prevItems, page)
        .then(async response => {
          if (response.body.data.length > 0) {
            prevItems = prevItems.concat(response.body.data)
            await this.fetchRoutingZones(country, includes, prevItems, response.body.pagination.page + 1)
          } else {
            this.routingZones = prevItems
            this.routingZonesSelect = prevItems.map((item) => {
              return {
                value: item.id,
                text: item.name
              }
            })
            this.routingZonesWithCoords = prevItems.map((item) => {
              return {
                id: item.id,
                text: item.name,
                value: {
                  coords: JSON.parse(JSON.stringify(item.area)).coordinates.map(linearRing =>
                    linearRing.slice(0, linearRing.length - 1)
                      .map(([lng, lat]) => ({lat, lng}))
                  )
                }
              }
            })
          }
        })
    },
    async fetchWarehouses(country = null, includes = []) {
      return catalogs.fetchWarehouses(country, includes)
        .then(response => {
          this.warehouses = response.body.data
          this.warehousesSelect = this.warehouses.map((item) => {
            return {
              value: item.place_id,
              text: item.reference
            }
          })
        })
    },
    async fetchWarehousesById(country = null, includes = []) {
      return catalogs.fetchWarehousesById(country, includes)
        .then(response => {
          this.warehousesById = response.body.data
          this.warehousesByIdSelect = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.reference
            }
          })
        })
    },
    async fetchShippingSizes() {
      return catalogs.fetchShippingSizes()
        .then(response => {
          this.shippingSizes = response.body.data
          this.shippingSizesSelect = this.shippingSizes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchShippingTypes() {
      return catalogs.fetchShippingTypes()
        .then(response => {
          this.shippingTypes = response.body.data
          this.shippingTypesSelect = this.shippingTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchPlatforms() {
      return catalogs.fetchPlatforms()
        .then(response => {
          this.platforms = response.body.data
          this.platformsSelect = this.platforms.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchVehicleTypes() {
      return catalogs.fetchVehicleTypes()
        .then(response => {
          this.vehicleTypes = response.body.data
          this.vehicleTypesSelect = this.vehicleTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchRoles(setDisabledsByRole = false) {
      return catalogs.fetchRoles(setDisabledsByRole)
        .then(response => {
          this.roles = response.body.data
          if (!this.isMoova) {
            this.roles.splice(this.roles.findIndex(x => x.name === 'super-admin'), 1)
          }
          this.rolesSelect = this.roles.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          }).filter(role => {
            if (role.text === this.$roles.SUPER_ADMIN) {
              if (this.isSuperAdmin) {
                return true
              } else {
                return false
              }
            }
            if (role.text === this.$roles.ADMIN) {
              if (this.isSuperAdmin || this.isAdmin) {
                return true
              } else {
                return false
              }
            }
            return this.isSuperAdmin ||
              this.isAdmin ||
              ((this.isOperatorSupervisor || this.isOnboarding) && (role.text === this.$roles.OPERATOR || role.text === this.$roles.WAREHOUSE_OPS)) ||
              role.text !== this.$roles.ADMIN &&
              role.text !== this.$roles.OPERATOR_SUPERVISOR &&
              role.text !== this.$roles.ACCOUNTANT &&
              role.text !== this.$roles.ACCOUNT_APPROVER &&
              role.text !== this.$roles.INTERNATIONAL &&
              role.text !== this.$roles.COMMERCIAL &&
              role.text !== this.$roles.OPERATOR &&
              role.text !== this.$roles.WAREHOUSE_OPS &&
              role.text !== this.$roles.INTEGRATOR &&
              role.text !== this.$roles.HEAD_OPERATIONS &&
              role.text !== this.$roles.HEAD_SALES &&
              role.text !== this.$roles.ONBOARDING &&
              role.text !== this.$roles.COURIER_ADMIN
          }).map(role => {
            if (setDisabledsByRole) {
              if (this.isSuperAdmin || this.isAdmin || this.isOnboarding || (this.isCourierAdmin && role.text === this.$roles.COURIER)) {
                return role
              } else {
                return {...role, disabled: true}
              }
            } else {
              return role
            }
          })
        })
    },
    async fetchReceiverTypes() {
      return catalogs.fetchReceiverTypes()
        .then(response => {
          this.receiverTypes = response.body.data
        })
    },
    async fetchShippingStatusReasons() {
      return catalogs.fetchShippingStatusReasons()
        .then(response => {
          for (let i = 0; i < response.body.data.length; i++) {
            if (!this.shippingStatusReasons[response.body.data[i].event]) {
              this.shippingStatusReasons[response.body.data[i].event] = []
            }
            // reset the shipping_status_reasons events to match shipping statuses
            if (response.body.data[i].event === 'PICKEDUP') {
              response.body.data[i].event = 'CONFIRMED'
            } else if (response.body.data[i].event === 'DELIVERED') {
              this.tobereturnedStatusReasons.push({name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id})
              response.body.data[i].event = 'INTRANSIT'
            }
            this.shippingStatusReasons[response.body.data[i].event].push({name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id})
          }
        })
    },
    async fetchEventTypes() {
      return catalogs.fetchEventTypes()
        .then(response => {
          this.eventTypes = response.body.data
          this.eventTypesSelect = this.eventTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchNotificationTypes() {
      return catalogs.fetchNotificationTypes()
        .then(response => {
          this.notificationTypes = response.body.data
          this.notificationTypesSelect = this.notificationTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchIndustries() {
      return catalogs.fetchIndustries()
        .then(response => {
          this.industries = response.body.data
          this.industriesSelect = this.industries.map((item) => {
            return {
              value: item.id,
              text: item.description
            }
          })
        })
    },
    async fetchCompaniesSettings() {
      return catalogs.fetchCompaniesSettings()
        .then(response => {
          this.companiesSettings = response.body.data
        })
    },
    async fetchCompaniesSegments() {
      return await catalogs.fetchCompaniesSegments()
        .then(response => {
          this.companiesSegments = response.body.data
          this.companiesSegmentsSelect = this.companiesSegments.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchDisableReasons() {
      return catalogs.fetchDisableReasons()
        .then(response => {
          this.disableReasons = response.body.data
          this.disableReasonsSelect = this.disableReasons.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchServices() {
      return catalogs.fetchServices()
        .then(response => {
          this.services = response.body.data
          this.servicesSelect = this.services.map((item) => {
            return {
              value: item.id,
              text: item.description || item.name
            }
          })
        })
    },
    async fetchOutsourcingModelMappings() {
      return catalogs.fetchOutsourcingModelMappings()
        .then(response => {
          this.outsourcingModelMappings = response.body
          this.outsourcingModelMappingsSelect = this.outsourcingModelMappings.map((item) => {
            return {
              value: item,
              text: item
            }
          })
        })
    },
    async fetchPlatforms3p() {
      return catalogs.fetchPlatforms3p()
        .then(response => {
          this.platforms3p = response.body.data
          this.platforms3pSelect = this.platforms3p.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    },
    async fetchOutsourcingCustomizations() {
      return catalogs.fetchOutsourcingCustomizations()
        .then(response => {
          this.outsourcingCustomizations = response.body.data
          this.outsourcingCustomizationsSelect = this.outsourcingCustomizations.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
        })
    }
  }
}
